import OrganizationInterface from '@/interfaces/Organization.interface';
import api from '@/services/config';

export class OrganizationRest{
    getOrganizations(params: any): Promise<any> {
        return api.get('/organization', { params }).then((response) => response.data);
    }

    getOrganizationById(id: any): Promise<any> {
        return api.get(`/organization/${id}`).then((response) => response.data);
    }

    addOrganization(data: any): Promise<any> {
        return api.post('/organization', data).then((response) => response.data);
    }

    updateOrganization(id: any, data: OrganizationInterface): Promise<any> {
        return api.put(`/organization/${id}`, data).then((response) => response.data);
    }

    deleteOrganization(id: any): Promise<OrganizationInterface> {
        return api.delete(`/organization/${id}`).then((response) => response.data);
    }

    updateOrganizationStatus(id: any): Promise<any> {
        return api.patch(`/organization/${id}/change-activate`).then((response) => response.data);
    }

    getAdressData(cep: any): Promise<any> {
        return api.get(`https://viacep.com.br/ws/${cep}/json/`).then((response) => response.data);
    }

    //Contact Organization Rest

    getContactOrganization(organizationId: any, params: any): Promise<any> {
        return api.get(`/${organizationId}/contact`, {params}).then((response) => response.data);
    }

    getContactOrganizationById(organizationId: any, id: any): Promise<any> {
        return api.get(`/${organizationId}/contact/${id}`).then((response) => response.data);
    }

    addContactOrganization(organizationId: any, data: any): Promise<any> {
        return api.post(`/${organizationId}/contact`, data).then((response) => response.data);
    }

    updateContactOrganization(organizationId: any, id: any, data: any): Promise<any> {
        return api.put(`/${organizationId}/contact/${id}`, data).then((response) => response.data);
    }

    deleteContactOrganization(organizationId: any, id: any): Promise<any> {
        return api.delete(`/${organizationId}/contact/${id}`).then((response) => response.data);
    }
    

}